import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonsAssociate } from '../../../questiontype/Associate/registry/SkeletonsAssociate';
import { SkeletonsMemorizePoints } from '../../../questiontype/MemorizePoints/registry/SkeletonsMemorizePoints';
import { SkeletonsCycleEnd } from '../../../questiontype/CycleEnd/registry/SkeletonsCycleEnd';
import { SkeletonsKnowAWord } from '../../../questiontype/KnowAWord/registry/SkeletonKnowAWord';
import { SkeletonsSortable } from '../../../questiontype/Sortable/registry/SkeletonsSortable';
import { SkeletonsMultiSelect } from '../../../questiontype/MultiSelect/registry/SkeletonsMultiSelect';
export class RareSkeletonsQuestiontypes extends SkeletonRegistryCategory {
    label = 'QuestionTypes';
    constructor(parent) {
        super(parent);
    }
    c_a = new SkeletonsAssociate(this);
    c_mp = new SkeletonsMemorizePoints(this);
    c_c = new SkeletonsCycleEnd(this);
    c_k = new SkeletonsKnowAWord(this);
    c_s = new SkeletonsSortable(this);
    c_ms = new SkeletonsMultiSelect(this);
}
